import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Pagination,
} from "@mui/material";

const AnalyticsUsersTable = ({
  columns = [],
  rows = [],
  loading = false,
  error = false,
  pagination = null,
  onPageChange,
}) => {
  if (loading) {
    return (
      <Box
        sx={{
          py: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ py: 3 }}>
        Failed to load users analytics.
      </Typography>
    );
  }

  if (!rows?.length) {
    return (
      <Typography sx={{ py: 3 }} color="text.secondary">
        No analytics data available.
      </Typography>
    );
  }

  return (
    <Paper sx={{ p: 2, borderRadius: 2 }}>
      {/* Table */}
      <TableContainer>
        <Table>
          {/* Table Header */}
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  align={col.align || "left"}
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.9rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row._id || index} hover>
                {columns.map((col) => (
                  <TableCell
                    key={col.key}
                    align={col.align || "left"}
                    sx={{ fontSize: "0.85rem" }}
                  >
                    {col.render ? col.render(row) : row[col.key] ?? "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {pagination?.totalPages > 1 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            onChange={(e, value) => onPageChange?.(value)}
            shape=""
          />
        </Box>
      )}
    </Paper>
  );
};

export default AnalyticsUsersTable;
